import { useAuth } from '../context/AuthContext';

export default function DemoBanner() {
  const { isDemoHesap, demoSonTarih } = useAuth();

  if (!isDemoHesap || !demoSonTarih) return null;

  const now = new Date();
  const kalanMs = demoSonTarih - now;
  const kalanGun = Math.ceil(kalanMs / (1000 * 60 * 60 * 24));
  const doldu = kalanMs <= 0;

  const formatTarih = (d) => d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });

  if (doldu) {
    return (
      <div className="mx-3 mb-2 bg-red-900/40 border border-red-500/50 rounded-lg px-3 py-2 text-xs">
        <div className="text-red-300 font-semibold">Demo süresi doldu</div>
        <div className="text-red-400/80 mt-0.5">Devam etmek için iletişime geçin.</div>
      </div>
    );
  }

  const renk = kalanGun <= 1
    ? 'bg-red-900/40 border-red-500/50 text-red-300'
    : kalanGun <= 3
    ? 'bg-yellow-900/40 border-yellow-500/50 text-yellow-300'
    : 'bg-blue-900/40 border-blue-500/50 text-blue-300';

  return (
    <div className={`mx-3 mb-2 ${renk} border rounded-lg px-3 py-2 text-xs`}>
      <div className="font-semibold flex items-center gap-1">
        <span className="w-1.5 h-1.5 rounded-full bg-current inline-block"></span>
        DEMO
      </div>
      <div className="opacity-80 mt-0.5">
        {kalanGun <= 1 ? 'Son gün!' : `${kalanGun} gün kaldı`} · {formatTarih(demoSonTarih)}
      </div>
    </div>
  );
}
